import React, { useEffect, useState } from 'react';
import SummaryApi from '../common';
import moment from 'moment';
import displayINRCurrency from '../helpers/displayCurrency';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import {  useNavigate, useParams } from 'react-router-dom';
import { MdOutlineDoneOutline } from 'react-icons/md';
import { CiTimer, CiDeliveryTruck } from 'react-icons/ci';
import { MdModeEdit } from 'react-icons/md'; 
import ChangeSalesMan from '../components/ChangeSalesMan';
import ChangeOrderStatus from '../components/ChangeOrderStatus';
import { RiRefund2Fill } from "react-icons/ri";
import defaultImage from '../assest/DAWACO_Icon.png'; 
import ROLE from '../common/role';
import DeleteOrders from '../components/DeleteOrders';
import { HiXCircle } from "react-icons/hi";
import { toast } from 'react-toastify';
import { FaPlus } from "react-icons/fa";
import AdminAddProductToOrder from '../components/AdminAddProductToOrder';



const AdminViewAnOrder = () => {
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
   
    const { userId, type } = useParams();  
    const user = useSelector(state => state?.user?.user);
    const [currentSalesman, setCurrentSalesman] = useState(''); 
    const [selectedOrderId, setSelectedOrderId] = useState(null);
    const [showChangeSalesMan, setShowChangeSalesMan] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState('');
    const [loadingPage, setLoadingPage] = useState(false);
    const navigate = useNavigate();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);


    const [selectedProducts, setSelectedProducts] = useState([]);
    const [editedPrice, setEditedPrice] = useState({});
    const [editedQuantity, setEditedQuantity] = useState({});
    const [editedBonus, setEditedBonus] = useState({});
    const [productData, setProductData] = useState({}); 


    useEffect(() => {
        setLoadingPage(true);
        const loadingTimeout = setTimeout(() => {
          
          setLoadingPage(false);
          navigate("/");
        }, 10000); 
      
        if (user) {
          if (user?.role !== ROLE.ADMIN) {
            navigate('/');
            setLoadingPage(false);
          } 
          else {
            if(user?.type === "Admin"){
                navigate('/admin-panel/all-users');
                setLoadingPage(false);
            }
            else{
                setLoadingPage(false);
                clearTimeout(loadingTimeout);
            }
           
          }
        } 
      
        // Clear the timeout when the component unmounts or the effect is rerun
        return () => clearTimeout(loadingTimeout);
      }, [user, navigate]);
    

    useEffect(() => {
        if (userId && type) {
            fetchOrdersByUserId(userId, type);  
        }
    }, [userId, type]);

    const fetchOrdersByUserId = async (orderId, orderType) => {
        try {
            setLoading(true);
        
            const apiUrl = `${SummaryApi.userViewOrderDetails.url}/${orderId}/${orderType}`;
            const method = SummaryApi.userViewOrderDetails.method;
        
            const response = await fetch(apiUrl, {
                method: method,
                credentials: 'include',
            });
        
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to fetch data');
            }
        
            const responseData = await response.json();
            if (responseData.success) {
                let orders = responseData.data;
                
                if (!Array.isArray(orders)) {
                    orders = [];
                }
        
                const sortedData = orders.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                setData(sortedData || []);
            } else {
                setError(responseData.message || 'Failed to fetch data');
                setData([]);
            }
        } catch (error) {
            setError(error.message || 'Error fetching orders');
        } finally {
            setLoading(false);
        }
    };

    const fetchProductDetails = async (productId) => {
        setLoading(true);
    
        try {
            const response = await fetch(SummaryApi.productDetails.url, {
                method: SummaryApi.productDetails.method,
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ productId: productId, type: type })
            });
    
            const dataResponse = await response.json();
    
            if (!dataResponse.success || !dataResponse.data) {
                throw new Error("Failed to fetch product details");
            }
    
            // Update the product data for the specific product
            setProductData((prevData) => ({
                ...prevData,
                [productId]: dataResponse.data,
            }));
        } catch (error) {
            console.error(error.message);
        } finally {
            setLoading(false);
        }
    };
    

    
    

    const getStatusColor = (status) => {
        switch (status) {
            case 'accepted':
                return 'bg-blue-800 text-white';
            case 'pending':
                return 'bg-yellow-600 text-white';
            case 'rejected':
                return 'bg-red-800 text-white';
            case 'refused':
                return 'bg-red-800 text-white';    
            case 'done':
                return 'bg-green-100 text-green-800';
            default:
                return 'bg-gray-700 text-white';
        }
    };
    

    const handleDeleteClick = (orderId) => {
        setSelectedOrderId(orderId); // Set the selected order ID
        setShowDeleteModal(true);   // Show the modal
    };
    const handleAddClick = (orderId) => {
        setSelectedOrderId(orderId); 
        setShowAddModal(true);   
    };



    const handleStatusClick = (orderId, currentStatus) => {
        setSelectedOrderId(orderId);
        setSelectedStatus(currentStatus);
        setShowChangeSalesMan(false); 
      };
      
      const handleChangeSalesManClick = (orderId, salesManName) => {
        setSelectedOrderId(orderId);
        setCurrentSalesman(salesManName || '');
        setShowChangeSalesMan(true);
      };

      const closeModal = () => {
        setSelectedOrderId(null);
        setShowDeleteModal(false);
        setShowAddModal(false);
        setSelectedStatus('');
        setShowChangeSalesMan(false); 
      };
    
      const refreshData = async () => {
      await  fetchOrdersByUserId(userId,type)
       
    };
    const handleCheckboxChange = (productId) => {
        if (selectedProducts.includes(productId)) {
            // If already selected, remove it
            setSelectedProducts((prev) => prev.filter((id) => id !== productId));
        } else {
            // Add product to selected list and fetch details
            setSelectedProducts((prev) => [...prev, productId]);
            fetchProductDetails(productId); // Fetch details when selected
        }
    };
    

    const handlePriceChange = (productId, value) => {
        const sanitizedValue = value !== "" ? Math.max(0, parseInt(value, 10) || 0) : 0; // Ensure positive number or default to 0
        setEditedPrice((prev) => ({ ...prev, [productId]: sanitizedValue }));
    };
    
    const handleQuantityChange = (productId, value) => {
        const sanitizedValue = value !== "" ? Math.max(0, parseInt(value, 10) || 0) : 0; // Default to 0 if empty
        setEditedQuantity((prev) => ({ ...prev, [productId]: sanitizedValue }));
    };
    const handleBonusChange = (productId, value) => {
        const sanitizedValue = value !== "" ? Math.max(0, parseInt(value, 10) || 0) : 0; // Default to 0 if empty
        setEditedBonus((prev) => ({ ...prev, [productId]: sanitizedValue }));
    };
    
    
    const handleEditClick = async (orderId, orderStatus) => {
        if (orderStatus === 'done' || orderStatus === 'refused') {
          // Don't allow editing on done or refused orders
          toast.error("Cannot edit this order as it is already completed or refused.");
          return;
        }
      
        // Prepare updated products with new price and quantity
        const updatedProducts = selectedProducts.map((productId) => {
          const newPrice = editedPrice[productId]; // New price (only for the order, not the product)
          const newQuantity = editedQuantity[productId]; // New quantity
          const newBonus= editedBonus[productId];
          
          return {
            productId,
            newPrice,
            newQuantity,
            newBonus
          };
        });
      
        // Call the backend to update the order
        try {




          const response = await fetch(SummaryApi.updateOrder.url, {
            method: SummaryApi.updateOrder.method,
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              orderId,
              updatedProducts,
              type,
              admin:user
            }),
          });
      
          const data = await response.json();
      
          if (data.success) {
            toast.success("تم تعديل الطلب بنجاح");
            fetchOrdersByUserId(userId, type); 
            selectedProducts.forEach((productId) => {
                fetchProductDetails(productId); // Fetch product details after editing the order
            });
            
          } else {
            toast.error(data.message);
          }
        } catch (error) {
          toast.error("Error updating the order.");
        }
        
        
      };
      
    
    

    if (loading) {
        return (
            <div className="flex justify-center items-center h-64">
                <AiOutlineLoading3Quarters className="animate-spin text-4xl text-blue-500" />
            </div>
        );
    }

    return (
        <div className='min-h-[calc(100vh-120px)] flex'>
          

            <main className='w-full h-full p-4'>
                {error ? (
                    <p className="text-red-500">{error}</p>
                ) : data.length === 0 ? (
                    <p>لا يوجد طلب حاليا</p>
                ) : (
                    data.map((item, index) => (
                        <div key={item?._id || index} className="my-4">
                            <p className="font-medium text-lg">{moment(item?.createdAt).format('LLL')}</p>
                            <div className="border rounded p-4">
                                <div className="flex flex-col lg:flex-row justify-between">
                                    <div className="grid gap-1">
                                        {item.productDetails?.map((product, index) => (
                                            <div key={product?.productId + index} className="flex gap-3 bg-slate-100 p-2">
                                               {item?.status !== 'done' &&item?.status !== 'refused' &&  <input
                                                    type="checkbox"
                                                    checked={selectedProducts.includes(product.productId)}
                                                    onChange={() => handleCheckboxChange(product.productId)}
                                                    className="checkbox"
                                                />
                                            }
                                                <img
                                                    src={product?.productImage?.[0] || defaultImage} 
                                                    className="w-28 h-20 bg-slate-200 object-scale-down"
                                                    alt={product?.productName }
                                                />
                                                <div>
                                                    <div className="font-medium text-lg text-ellipsis line-clamp-1">{product?.productName}</div>
                                                    <div className="mt-1">
                                                        <div className="text-lg text-blue-800">
                                                            {displayINRCurrency(product?.unitPrice)} : سعر المنتج الواحد
                                                        </div>
                                                        <div className="mt-1">
                                                            الكمية : {product?.quantity}
                                                        </div>

                                                        {product?.bonus >0 &&(
                                                        <div className="mt-1">
                                                            البونص  : {product?.bonus}
                                                        </div>
                                                        )}

                                                        <div className="mt-1">
                                                            {displayINRCurrency(product?.quantity * product?.unitPrice)} : سعر الكمية المطلوبة من هذا المنتج
                                                        </div>
                                                    </div>
                                             {selectedProducts.includes(product.productId) && (
                                            <div className="flex flex-col gap-2 mt-2">
                                                {/* Price Section */}
                                                <div className="flex items-center gap-2">
                                                    <input
                                                        id={`price-${product.productId}`}
                                                        type="number"
                                                        value={editedPrice[product.productId] !== undefined ? editedPrice[product.productId] : product.unitPrice}
                                                        onChange={(e) => handlePriceChange(product.productId, e.target.value)}
                                                        onInput={(e) => {
                                                            
                                                            if (e.target.value < 0) e.target.value = "";
                                                        }}
                                                        placeholder="أدخل السعر الجديد"
                                                        className="p-1 text-sm mt-1 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400 w-24"
                                                        min="0"
                                                        
                                                    />
                                                    <label htmlFor={`price-${product.productId}`} className="text-xs font-medium text-gray-700 w-22">
                                                        : سعر المنتج الجديد لهذا الطلب فقط
                                                    </label>
                                                </div>

                                                {/* Quantity Section */}
                                                <div className="flex items-center gap-2">
                                                    <input
                                                        id={`quantity-${product.productId}`}
                                                        type="number"
                                                        value={editedQuantity[product.productId] !== undefined ? editedQuantity[product.productId] : product.quantity}
                                                        onChange={(e) => handleQuantityChange(product.productId, e.target.value)}
                                                        onInput={(e) => {
                                                            const maxQuantity = productData[product.productId]?.quantity + product.quantity; // Calculate max allowable quantity
                                                            let sanitizedValue = parseInt(e.target.value, 10);
                                                        
                                                            // Ensure the value is not negative and within the allowable range
                                                            if (isNaN(sanitizedValue) || sanitizedValue < 0) {
                                                                sanitizedValue = 0; // Default to 0 if invalid or negative
                                                            } else if (sanitizedValue > maxQuantity) {
                                                                sanitizedValue = maxQuantity; // Clamp to max quantity
                                                            }
                                                        
                                                            e.target.value = sanitizedValue; // Set the sanitized value in the input
                                                        
                                                            // Update bonus dynamically based on new quantity
                                                            const newQuantity = sanitizedValue; // Validated value
                                                            const maxBonus = maxQuantity - newQuantity; // Recalculate max bonus
                                                            setEditedBonus((prev) => ({
                                                                ...prev,
                                                                [product.productId]: Math.min(prev[product.productId] || 0, maxBonus),
                                                            }));
                                                        }}
                                                        
                                                        placeholder="أدخل الكمية المطلوبة"
                                                        className="p-1 text-sm mt-1 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400 w-24"
                                                        min="0"
                                                        max={productData[product.productId]?.quantity + product?.quantity  }
                                                    />
                                                    <label htmlFor={`quantity-${product.productId}`} className="text-xs font-medium text-gray-700 w-22">
                                                        : الكمية الجديدة
                                                    </label>
                                                </div>

                                                  {/* Bonus Section */}
                                                     <div className="flex items-center gap-2">
                                                    <input
                                                        id={`bonus-${product.productId}`}
                                                        type="number"
                                                        value={
                                                        editedBonus[product.productId] !== undefined
                                                            ? editedBonus[product.productId]
                                                            : product.bonus
                                                        }
                                                        onChange={(e) => handleBonusChange(product.productId, e.target.value)}
                                                        onInput={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            const maxBonus = 
                                                                (productData[product.productId]?.quantity || 0) +
                                                                (product?.quantity || 0) -
                                                                (editedQuantity[product.productId] || product?.quantity || 0);
                                                        
                                                            if (value < 0) e.target.value = ""; // Reset if the value is less than 0
                                                            if (value > maxBonus) e.target.value = maxBonus; // Clamp the value to max bonus
                                                        }}
                                                        
                                                        placeholder="أدخل الكمية المطلوبة"
                                                        className="p-1 text-sm mt-1 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400 w-24"
                                                        min="0"
                                                        max={
                                                        (productData[product.productId]?.quantity || 0) +
                                                        (product?.quantity || 0) -
                                                        (editedQuantity[product.productId] || product?.quantity || 0)
                                                        }
                                                    />
                                                    <label
                                                        htmlFor={`bonus-${product.productId}`}
                                                        className="text-xs font-medium text-gray-700 w-22"
                                                    >
                                                        :البونص الجديد 
                                                    </label>
                                                    </div>


                                                <span>
                                                    الكمية الموجودة بالمخزن: {productData[product.productId]?.quantity}
                                                </span>
                                                <span>
                                                {displayINRCurrency(productData[product.productId]?.price)} :   السعر الأصلى لهذا المنتج
                                                </span>
                                            </div>
                                        )}



                                                
                                                </div>
                                                
                                            </div>
                                        ))}
                                    </div>

                                    <div className="font-semibold ml-auto w-fit lg:text-lg">
                                        
                                    <div className="relative">
                                    {item?.status !== 'done' &&item?.status !== 'refused' &&  (
                                        <button
                                    className="absolute top-2 right-2 bg-red-300 p-2 w-10 h-10 lg:w-auto lg:h-auto rounded-full cursor-pointer hover:bg-red-600 hover:text-white flex items-center justify-center"
                                    onClick={() => handleDeleteClick(item?._id)}
                                    >
                                         
                                    <HiXCircle className="text-base lg:text-2xl mr-2" />
                                    <span>
                                        رفض الطلب
                                    </span>
                                    </button>

                                        )}
                                    {item?.status !== 'done' &&item?.status !== 'refused' &&  (
                                        <button
                                    className="absolute top-16 right-2 bg-green-300 p-2 w-10 h-10 lg:w-auto lg:h-auto rounded-full cursor-pointer hover:bg-green-600 hover:text-white flex items-center justify-center"
                                    onClick={() => handleAddClick(item?._id)}
                                    >
                                         
                                    <FaPlus className="text-base lg:text-2xl mr-2" />
                                    <span>
                                       اضف منتج
                                    </span>
                                    </button>

                                        )}
                               
                                 
                                    </div>
                                    
                                    


                                        <div className="flex items-center mb-2 gap-2">
                                            <span className="text-xl font-bold text-blue-800">
                                                {displayINRCurrency(item?.totalPrice || 0)}
                                            </span>
                                            <span className="block mr-2">: المبلغ الاجمالى</span>
                                        </div>

                                        <div className="flex flex-col gap-y-6">
                                            {/* Status Section */}
                                            <div className="flex items-center">
                                                <span className="flex items-center">
                                                    {item?.status === 'pending' ? (
                                                        <>
                                                            <CiTimer className="inline-block mr-2 text-yellow-500 text-2xl" />
                                                            <span className="bg-yellow-100 text-yellow-800 px-4 py-2 rounded-lg text-lg font-medium">
                                                                جاري تحضير الطلب بالمخزن
                                                            </span>
                                                        </>
                                                    ) : item?.status === 'accepted' ? (
                                                        <>
                                                            <CiDeliveryTruck className="inline-block mr-2 text-blue-600 text-2xl" />
                                                            <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-lg text-lg font-medium">
                                                                تم تحضير الطلب وجاهز للتوصيل
                                                            </span>

                                                        </>
                                                    ) : item?.status === 'done' ? (
                                                        item?.type==='order'?
                                                        <>
                                                            <MdOutlineDoneOutline className="inline-block mr-2 text-green-500 text-2xl" />
                                                            <span className="bg-green-100 text-green-800 px-4 py-2 rounded-lg text-lg font-medium">
                                                                تم ايصال الطلب بنجاح
                                                            </span>
                                                        </>:
                                                         <>
                                                         <RiRefund2Fill className="inline-block mr-2 text-green-500 text-2xl" />
                                                         <span className="bg-green-100 text-green-800 px-4 py-2 rounded-lg text-lg font-medium">
                                                           (استرجاع) تم اعادة الطلب بنجاح
                                                         </span>
                                                     </>

                                                    ): item?.status === 'refused' ? (
                                                        <>
                                                            <HiXCircle className="inline-block mr-2 text-red-600 text-3xl" />
                                                            <span className="bg-red-100 text-red-800 px-2 py-1 rounded-lg text-lg font-medium">
                                                                تم رفض الطلب
                                                            </span>

                                                        </>
                                                    ) : (
                                                        <span className={`px-4 py-2 rounded-lg text-lg font-medium ${getStatusColor(item?.status)}`}>
                                                            {item?.status}
                                                        </span>
                                                    )}
                                                </span>
                                            </div>

                                            {item?.type==='order'&&
                                           <div className="mb-2 ml-20">
                                                {item.orderSalesManName &&   <p className="font-medium text-lg">
                                                    <span className="font-semibold text-gray-700"></span>  ({item?.orderSalesManName}): تم الطلب بواسطة مندوب المبيعات
                                                </p>}
                                                {item.orderSalesManName==='' &&   <p className="font-medium text-lg">
                                                    <span className="font-semibold text-gray-700"></span> تم الطلب بواسطة الصيدلية 
                                                </p>}
                                                {item.refundAdminId &&   <p className="font-medium text-lg">
                                                    <span className="font-semibold text-gray-700"></span>  ({item?.refundAdminName}) :تم الرفض بواسطة الادمن  
                                                </p>}
                                                {item.editedAdminId &&   <p className="font-medium text-lg">
                                                    <span className="font-semibold text-gray-700"></span>  ({item?.editedAdminName}) :تم التعديل بواسطة الادمن  
                                                </p>}

                                                <p className="font-medium text-lg">
                                                    <span className="font-semibold text-gray-700">كود الطلب:</span> #{item?.orderCode}
                                                </p>

                                                {item.clientNotes !=="" &&
                                                    <p className="font-medium text-lg">
                                                        <span className="font-semibold text-red-700">ملحوظات : </span> {item.clientNotes}
                                                    </p>
                                                }


                                            </div>} 

                                           {item?.type==='refund'&&
                                           <div className="mb-2 ml-20">
                                                <p className="font-medium text-lg">
                                                    <span className="font-semibold text-gray-700">كود العملية (المرتجع) :</span> #{item?.orderCode}
                                                </p>

                                                <p className="font-medium text-lg">
                                                    <span className="font-semibold text-gray-700">مرتجع من الطلب :  </span> #{item?.refundFromOrderNumber}
                                                </p>
                                                {item.refundSalesManId===""&&item.refundAdminId===""&&
                                                <p className="font-medium text-lg">
                                                    <span className="font-semibold text-gray-700">تم بواسطة الصيدلية </span> 
                                                </p>}
                                                {item.refundSalesManId!==""&&
                                                <p className="font-medium text-lg">
                                                    <span className="font-semibold text-gray-700">تم بواسطة مندوب المبيعات </span> ({item.refundSalesManName})
                                                </p>}
                                                {item.refundSalesManId===""&&item.refundAdminId!==""&&
                                                <p className="font-medium text-lg">
                                                    <span className="font-semibold text-gray-700">تم بواسطة الادمن </span> ({item.refundAdminName})
                                                </p>}

                                            </div>} 

                                            {/* Order Details Section */}
                                            <div className="mb-4 p-4 border border-gray-200 rounded-lg bg-white shadow-md text-right">
                                                <h2 className="text-xl font-semibold mb-4 text-blue-900 "> : معلومات مندوب المبيعات  </h2>
                                                <div className="mb-2">
                                                    <p className="font-medium text-lg">
                                                        <span className="font-semibold text-gray-500"> الاسم : </span> {item?.salesManName ? item?.salesManName : 'لم يتم تكليف مندوب مبيعات بعد بهذا الطلب'}
                                                    </p>
                                                </div>
                                                <div className="mb-2">
                                                    <p className="font-medium text-lg">
                                                        <span className="font-semibold text-gray-500"> البريد الالكتروني  : </span> {item?.salesManEmail ? item?.salesManEmail : 'لم يتم تكليف مندوب مبيعات بعد بهذا الطلب'}
                                                    </p>
                                                </div>
                                                <div className="mb-2">
                                                    <p className="font-medium text-lg">
                                                        <span className="font-semibold text-gray-500">رقم الهاتف المحمول  : </span> {item?.salesManMobileNumber ? item?.salesManMobileNumber : 'لم يتم تكليف مندوب مبيعات بعد بهذا الطلب'}
                                                    </p>
                                                </div>
                                                <div className="mb-2">
                                                    <p className="font-medium text-lg">
                                                        <span className="font-semibold text-gray-500">اسم الشركة    : </span> {type==='Medicine'?'شركة دواكو':'شركة مستحضرات التجميل'}
                                                    </p>
                                                </div>
                                                {user?.pharmacistOrPharmacy==='pharmacist' &&
                                                <div className="mb-2">
                                                    <p className="font-medium text-lg">
                                                        <span className="font-semibold text-gray-500">العنوان : </span> {item?.shippingAddress || 'لم يتم تحديد عنوان الشحن'}
                                                    </p>
                                                </div>
                                                }
                                            </div>
                                            {selectedProducts.length > 0 && item?.status !== 'done' && item?.status !== 'refused' && (
                                                 <div className="flex flex-col items-center">
                                            <button
                                                className="bg-yellow-400 p-4 w-24 h-14 lg:w-52 lg:h-12 rounded-full cursor-pointer hover:bg-yellow-600 hover:text-white flex items-center justify-center"
                                                onClick={() => handleEditClick(item?._id, item?.status)}
                                            >
                                                <MdModeEdit className="text-xl lg:text-xl mr-3" />
                                                <span className="text-base lg:text-lg font-semibold">
                                                تاكيد تعديل الطلب
                                                </span>
                                            </button>
                                            <p className="mt-4 text-red-500 font-semibold text-center">
                                             يرجي العلم انه سيتم تغيير المنتجات التي تم تحديدها فقط 
                                            </p>
                                        </div>
                                            
                                            )}


                                            
                                        </div>
                                        
                                    </div>

                                </div>
                                                                              {/* Action Buttons */}
          <div className="mt-4">
            {  item?.status !== 'refused' &&item?.type === 'order' && (
              <button
                className="bg-blue-100 w-full lg:w-auto p-2 rounded-full cursor-pointer hover:bg-blue-500 hover:text-white mb-2 flex items-center justify-center"
                onClick={() => handleStatusClick(item?._id, item?.status)}
              >
                <MdModeEdit className="text-xl" />
                <span className="ml-2">تعديل حالة الطلب</span>
              </button>
            )}

            {item?.status === 'accepted' && item?.salesManName === '' && (
              <button
                className="bg-blue-100 w-full lg:w-auto p-2 rounded-full cursor-pointer hover:bg-blue-500 hover:text-white mb-2 flex items-center justify-center"
                onClick={() => handleChangeSalesManClick(item?._id, item?.salesManName)}
              >
                <MdModeEdit className="text-xl" />
                <span className="ml-2">وضع مندوب مبيعات مسؤول</span>
              </button>
            )}

            {item?.status === 'accepted' && item?.salesManName !== '' && (
              <button
                className="bg-blue-100 w-full lg:w-auto p-2 rounded-full cursor-pointer hover:bg-blue-500 hover:text-white mb-2 flex items-center justify-center"
                onClick={() => handleChangeSalesManClick(item?._id, item?.salesManName)}
              >
                <MdModeEdit className="text-xl" />
                <span className="ml-2">تعديل مندوب مبيعات الحالي</span>
              </button>
            )}
            
          </div>
          
                            </div>
                            
                        </div>
                    ))
                )}
                

            </main>
               {/* ChangeOrderStatus Component for Modal */}
      {selectedOrderId && !showChangeSalesMan &&!showDeleteModal&&!showAddModal &&(
      <ChangeOrderStatus
        orderId={selectedOrderId}
        currentStatus={selectedStatus}
        onClose={() => closeModal(false)}
        callFunc={refreshData}
        type={type}
      />
    )}

    {/* ChangeSalesMan Component for Modal */}
    {showChangeSalesMan && (
      <ChangeSalesMan
        requestId={selectedOrderId}
        currentSalesman={currentSalesman}
        onClose={() => closeModal(false)}
        callFunc={refreshData}
        type={type}
      />
    )}
    {/* Delete Orders Modal */}
    {showDeleteModal  && !showChangeSalesMan  &&  (
    <DeleteOrders
        orderId={selectedOrderId}
        
        type={type}
        onClose={() => closeModal(false)}
        callFunc={refreshData}
        
                />
   )}
   {/* Add products Modal */}
   {showAddModal  && !showChangeSalesMan  &&  (
    <AdminAddProductToOrder
        orderId={selectedOrderId}
        type={type}
        onClose={() => closeModal(false)}
        callFunc={refreshData}
        
                />
   )}
        </div>
    );
};

export default AdminViewAnOrder;
